import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface RemovePaymentMethodResponse {
  removePaymentMethod?: {
    id: GQL_ID
    removed: boolean
  }
}

interface RemovePaymentMethodVariables {
  removePaymentMethodId: GQL_ID
}

export const REMOVE_PAYMENT_METHOD = gql`
  mutation RemovePaymentMethod($removePaymentMethodId: ID!) {
    removePaymentMethod(id: $removePaymentMethodId) {
      id
      removed
    }
  }
`

export const useMutateRemovePaymentMethod = () =>
  useMutation<RemovePaymentMethodResponse, RemovePaymentMethodVariables>(
    REMOVE_PAYMENT_METHOD,
  )
